<template>
    <v-app class="bg-blank">
        <v-app-bar dense app>
            <v-spacer></v-spacer>
            <locale-select></locale-select>
        </v-app-bar>
        <v-main>
            <v-container fluid fill-height>
                <v-row align="center" no-gutters>
                    <v-col>
                        <home-bar></home-bar>
                        <v-fade-transition mode="out-in">
                            <router-view></router-view>
                        </v-fade-transition>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <snackbar></snackbar>
    </v-app>
</template>

<script>
    import HomeBar from "./components/HomeBar";
    import Snackbar from "./components/Snackbar";
    import LocaleSelect from "./components/LocaleSelect";

    export default {
        name: "BlankLayout",

        components: {
            HomeBar,
            Snackbar,
            LocaleSelect,
        },
    }
</script>

<style lang="scss">
    @import "resources/sass/variables";

    .theme--light.v-application.bg-blank {
        background-image: url('/img/bg.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom;
    }
</style>
